import React from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import checkValue from '../../../../../../../../utils/values';
import FiduciaPdf from '../../../DownloadPdf/components/FiduciaPdfComponents';

function PdfMonthlyPartnersPassedOn() {
  const monthlyFaresState = useSelector(
    (reducer: IReducer) => reducer.monthlyFares
  );

  let totalIncome = 0;
  let totalPassedOn = 0;
  let totalReceived = 0;

  return (
    <>
      <FiduciaPdf.ContainerLabelValues>
        <FiduciaPdf.Label>Tabela de repasses para parceiros:</FiduciaPdf.Label>
        <FiduciaPdf.Table>
          <FiduciaPdf.THead>
            <FiduciaPdf.Tr>
              <FiduciaPdf.Td
                width="25rem"
                style={{ color: '#202020', fontWeight: 500 }}>
                Parceiro
              </FiduciaPdf.Td>
              <FiduciaPdf.Td style={{ color: '#202020', fontWeight: 500 }}>
                Recebido
              </FiduciaPdf.Td>
              <FiduciaPdf.Td style={{ color: '#202020', fontWeight: 500 }}>
                Repassado
              </FiduciaPdf.Td>
              <FiduciaPdf.Td style={{ color: '#202020', fontWeight: 500 }}>
                Receita
              </FiduciaPdf.Td>
            </FiduciaPdf.Tr>
          </FiduciaPdf.THead>
          <FiduciaPdf.TBody>
            {monthlyFaresState.partnerPassedOn.map((partner) => {
              totalIncome += partner.income;
              totalPassedOn += totalPassedOn + partner.valuePassedOn;
              totalReceived += totalReceived + partner.valueReceived;
              return (
                <FiduciaPdf.Tr>
                  <FiduciaPdf.Td width="25rem">{partner.partner}</FiduciaPdf.Td>
                  <FiduciaPdf.Td>
                    {checkValue(partner.valueReceived).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </FiduciaPdf.Td>
                  <FiduciaPdf.Td>
                    {checkValue(partner.valuePassedOn).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </FiduciaPdf.Td>
                  <FiduciaPdf.Td>
                    {checkValue(partner.income).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </FiduciaPdf.Td>
                </FiduciaPdf.Tr>
              );
            })}
          </FiduciaPdf.TBody>
          <FiduciaPdf.THead>
            <FiduciaPdf.Tr borderBottom="none">
              <FiduciaPdf.Td
                width="25rem"
                style={{ color: '#202020', fontWeight: 500 }}>
                Total
              </FiduciaPdf.Td>
              <FiduciaPdf.Td style={{ color: '#202020', fontWeight: 500 }}>
                {totalReceived.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </FiduciaPdf.Td>
              <FiduciaPdf.Td style={{ color: '#202020', fontWeight: 500 }}>
                {totalPassedOn.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </FiduciaPdf.Td>
              <FiduciaPdf.Td style={{ color: '#202020', fontWeight: 500 }}>
                {totalIncome.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </FiduciaPdf.Td>
            </FiduciaPdf.Tr>
          </FiduciaPdf.THead>
        </FiduciaPdf.Table>
      </FiduciaPdf.ContainerLabelValues>
    </>
  );
}

export default PdfMonthlyPartnersPassedOn;
